module.exports = __webpack_public_path__ + "static/img/02.728f88b7.jpg";